// extracted by mini-css-extract-plugin
export default {"idTitle":"IdHead_idTitle__WAihB","icon":"IdHead_icon__OHbwT","title":"IdHead_title__1+11o","indicator":"IdHead_indicator__3YwtO"};